// Time, handed to everything that needs it, so a test can hand in its own.

export type Cancel = () => void

export type Clock = {
  readonly now: () => number
  readonly after: (ms: number, f: () => void) => Cancel
  readonly every: (ms: number, f: () => void) => Cancel
}

export const browserClock = (): Clock => ({
  now: () => Date.now(),
  after: (ms, f) => {
    const t = setTimeout(f, ms)
    return () => clearTimeout(t)
  },
  every: (ms, f) => {
    const t = setInterval(f, ms)
    return () => clearInterval(t)
  },
})
